// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__NKNig","notes":"Notes_notes__3DyT_","note":"Notes_note__1B1Sq","markdown":"Notes_markdown__17Fqk"};